import {
    Col,
    message,
    PageHeader,
    Row,
    Spin,
    Select,
    Checkbox,
    Space,
    Tabs,
  } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  import { connect } from "react-redux";
  // import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
  import {
    SelectItem,
    Form,
    FormItem,
    cuentaMask,
    RangePickerItem,
    TableItem,
    dineroDisabledMask,
    ButtonItem,
    ErrorItem,
    SelectInsumosItem
  } from "../../../../Components/Items";
  import reportesDeVentasPdf from "../../../../Pdf/reporteDeVentasPdf";
  import { FileExcelOutlined, /*FilePdfOutlined*/ } from "@ant-design/icons";
  import * as XLSX from "xlsx";
  import moment from "moment";
  import "moment/locale/es";
  moment.locale("es");
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  
  const { Option } = Select;
  const { TabPane } = Tabs;
  
  class ReporteCostoProduccion extends Component {
    state = {
      loading: false,
      pdf: null,
      objetoClientes: null,
      todasClientes: null,
      objetoInsumos: null,
      todasInsumos: null,
      objetoUsuarios: null,
      todasUsuarios: null,
      objetoProyectos: null,
      todasProyectos: null,
      objetoUniadesDeNegocio: null,
      todasUniadesDeNegocio: null,
      dataReporte: null,
      todasProducciones: [],
      dataGrafico: [],
      subtotal: 0,
      totalImpuestos: 0,
      total: 0,
      totalRetenciones: 0,
      totalACobrar: 0,
      desglosarProductos: false
    };
  
    atras() {
        this.props.history.goBack();
    }
  
    async componentDidMount() {
      this.setState({ loading: true });
      await axios
        .post(
          "usuarios/selectUsuariosEmpresa",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasUsuarios: res.data });
            this.setState({
              objetoUsuarios: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre +
                      " " +
                      value.apellidoPaterno +
                      " " +
                      value.apellidoMaterno}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProyectos: res.data });
            this.setState({
              objetoProyectos: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "unidadesdenegocio/selectUnidadesDeNegocio",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasUniadesDeNegocio: res.data });
            this.setState({
              objetoUniadesDeNegocio: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {cuentaMask(
                      value.nivel1 +
                        value.nivel2 +
                        value.nivel3 +
                        value.nivel4 +
                        value.nivel5
                    ) +
                      " - " +
                      value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      this.consultarReporteCostoProduccion({
        periodo: [moment().subtract(1, "month"), moment()],
        usuarios: 0,
        insumos: 0,
        filtrarProyecto: 0,
        estadoFacturas: 5,
      });
    }
  
    consultarReporteCostoProduccion(values) {
      this.setState({ loading: true });
      axios
        .post(
          "reportesDeProduccion/reporteCostoProduccion",
          { ...values, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            this.setState({
              loading: false,
              dataReporte: res.data,
              todasProducciones: res.data.producciones,
              subtotal: res.data.subtotal,
              totalImpuestos: res.data.totalImpuestos,
              total: res.data.total,
              totalRetenciones: res.data.totalRetenciones,
              totalACobrar: res.data.totalACobrar,
              desglosarProductos: res.data.desglosarProductos,
            });
          } else if (res.data.success === 1) {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          } else {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          }
          this.setState({ loading: false });
        });
    }
  
    descargarExcel() {
      let datosDescargar = []
      if(this.state.desglosarProductos){
        for (const valueVenta of this.state.todasProducciones) {
          if(valueVenta.folio === ''){
            const venta = this.state.todasProducciones.find(todasproducciones => todasproducciones.folio !== '' && todasproducciones._id.toString() === valueVenta._id.toString())
            datosDescargar.push({
              Folio: venta.folio,
              "# Factura": venta.facturaNumero,
              "# Remision": venta.remisionNumero,
              "Codigo Cliente": venta.codigoCliente,
              "Clave Cliente": venta.claveCliente,
              Fecha: venta.fechaFactura,
              Cliente: venta.cliente,
              "Codigo Insumo": valueVenta.codigoCliente,
              "Clave Insumo": valueVenta.claveCliente,
              "Cantidad": valueVenta.fechaFactura,
              "Descripcion": valueVenta.cliente,
              "Familia": valueVenta.familia,
              "Precio Unitario": valueVenta.total,
              "Descuento": valueVenta.descuento,
              Costo: valueVenta.costoTotal, 
              "Subtotal Insumo": valueVenta.totalPagado,
              "Precio Con Impuestos": valueVenta.saldo,
              "Total Insumo": valueVenta.estado,
              "Fecha probable de pago": venta.fechaPago,
              "Total A Cobrar": venta.totalPagar,
              "Fecha Vencimiento": venta.fechaVencimiento,
              Total: venta.total,
              Abonos: venta.totalPagado,
              Saldo: venta.saldo,
              Estado: venta.estado,
              Vendedor: venta.vendedor,
            })
          }
        }
      }else{
        datosDescargar = this.state.todasProducciones.map((valueVenta) => {
          return {
            Folio: valueVenta.folio,
            "# Factura": valueVenta.facturaNumero,
            "# Remision": valueVenta.remisionNumero,
            "Codigo Cliente": valueVenta.codigoCliente,
            "Clave Cliente": valueVenta.claveCliente,
            Fecha: valueVenta.fechaFactura,
            Cliente: valueVenta.cliente,
            "Fecha probable de pago": valueVenta.fechaPago,
            "Total A Cobrar": valueVenta.totalPagar,
            "Fecha Vencimiento": valueVenta.fechaVencimiento,
            Total: valueVenta.total,
            Costo: valueVenta.costoTotal,
            Abonos: valueVenta.totalPagado,
            Saldo: valueVenta.saldo,
            Estado: valueVenta.estado,
            Vendedor: valueVenta.vendedor,
          };
        });
      }
      const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte Ventas");
      //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
      //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workbook, `Reporte_De_Ventas_${moment().locale("es").format("L")}.xlsx`);
    }
  
    descargarPdf() {
      pdfMake
        .createPdf(reportesDeVentasPdf(this.state.dataReporte))
        .download(`Reporte_De_Ventas_${moment().locale("es").format("L")}`);
    }
  
    onFinishFailed(e) {
      ErrorItem(e);
    }
    render() {
      const columns = [
        {
          title: "Numero",
          dataIndex: "numero",
          key: "numero",
          sorter: (a, b) => {
            if (a.numero < b.numero) {
              return -1;
            }
            if (a.numero > b.numero) {
              return 1;
            }
            return 0;
          },
          buscar: "numero",
          ellipsis: true,
        },
        {
          title: "Fecha",
          dataIndex: "fechaProduccion",
          key: "fechaProduccion",
          sorter: (a, b) => {
            if (moment(a.fechaProduccion, "DD/MM/YYYY") < moment(b.fechaProduccion, "DD/MM/YYYY")) {
              return -1;
            }
            if (moment(a.fechaProduccion, "DD/MM/YYYY") > moment(b.fechaProduccion, "DD/MM/YYYY")) {
              return 1;
            }
            return 0;
          },
          buscar: "fechaProduccion",
          ellipsis: true,
        },
        {
            title: "Insumo",
            dataIndex: "insumoGenerado",
            key: "insumoGenerado",
            sorter: (a, b) => {
              if (a.insumoGenerado < b.insumoGenerado) {
                return -1;
              }
              if (a.insumoGenerado > b.insumoGenerado) {
                return 1;
              }
              return 0;
            },
            buscar: "insumoGenerado",
            ellipsis: true,
          },
        {
            title: "Cantidad",
            dataIndex: "cantidad",
            key: "cantidad",
            sorter: (a, b) => {
              if (a.cantidad < b.cantidad) {
                return -1;
              }
              if (a.cantidad > b.cantidad) {
                return 1;
              }
              return 0;
            },
            buscar: "cantidad",
            ellipsis: true,
          },
        {
          title: "Costo P/U",
          dataIndex: "costo",
          key: "costo",
          sorter: (a, b) => {
            if (a.costo < b.costo) {
              return -1;
            }
            if (a.costo > b.costo) {
              return 1;
            }
            return 0;
          },
          buscar: "costo",
          render: (value) => dineroDisabledMask(value),
          align: "right",
          ellipsis: true,
        },
        {
            title: "Costo",
            dataIndex: "costoTotal",
            key: "costoTotal",
            sorter: (a, b) => {
              if (a.costoTotal < b.costoTotal) {
                return -1;
              }
              if (a.costoTotal > b.costoTotal) {
                return 1;
              }
              return 0;
            },
            buscar: "costoTotal",
            render: (value) => dineroDisabledMask(value),
            align: "right",
            ellipsis: true,
          },
        {
          title: "Estado",
          dataIndex: "estado",
          key: "estado",
          sorter: (a, b) => {
            if (a.estado < b.estado) {
              return -1;
            }
            if (a.estado > b.estado) {
              return 1;
            }
            return 0;
          },
          buscar: "estado",
          ellipsis: true,
        },
        {
            title: "Usuario",
            dataIndex: "usuario",
            key: "usuario",
            sorter: (a, b) => {
              if (a.usuario < b.usuario) {
                return -1;
              }
              if (a.usuario > b.usuario) {
                return 1;
              }
              return 0;
            },
            buscar: "usuario",
            ellipsis: true,
          },
      ];
      return (
        <>
          <Form
            ref={this.formRef}
            name="agregarUsuario"
            onFinish={this.consultarReporteCostoProduccion.bind(this)}
            onFinishFailed={this.onFinishFailed}
            initialValues={{
              periodo: [moment().subtract(1, "month"), moment()],
            }}
          >
            <PageHeader
              onBack={this.atras.bind(this)}
              title="Reporte Costo Produccion"
              style={{
                border: "1px solid rgb(235, 237, 240)",
                backgroundColor: "white",
                marginBottom: 10,
              }}
              extra={
                <div style={{ display: "flex", justifyContent: "right" }}>
                  <Space>
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarExcel()}
                        icon={<FileExcelOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar Excel
                      </ButtonItem>
                    )}
                    {/* {this.state.dataReporte && (
                      <Button
                        onClick={() => this.descargarPdf()}
                        icon={<FilePdfOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar PDF
                      </Button>
                    )} */}
                    <ButtonItem
                      type="primary"
                      htmlType="submit"
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Consultar
                    </ButtonItem>
                  </Space>
                </div>
              }
            />
            <Spin spinning={this.state.loading}>
              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  paddingTop: 5,
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <Tabs
                  style={{ margin: 0 }}
                  tabBarExtraContent={{
                    left: (
                      <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                        Filtros:
                      </h1>
                    ),
                  }}
                >
                  <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                    <FormItem name="periodo" required noStyle>
                      <RangePickerItem />
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="6" key="6" forceRender tab="Insumos">
                    <FormItem name="insumos" noStyle margin>
                      <SelectInsumosItem
                        empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                        headersToken={this.props.headersToken}
                        sinBorde
                        autoFocus
                        dropdownMatchSelectWidth={600}
                        width="90%"
                        placeholder="Insumo"
                        tiposInsumos="inventariables"
                        mode="multiple" 
                      />
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="3" key="3" forceRender tab="Usuarios">
                    <FormItem name="usuarios" margin noStyle>
                      <SelectItem
                        width="90%"
                        mode="multiple"
                        placeholder="Usuarios"
                      >
                        {this.state.objetoUsuarios}
                      </SelectItem>
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                    <Row>
                      <Col span={8}>
                        <FormItem
                          name="filtrarProyecto"
                          required
                          noStyle
                          initialValue={0}
                        >
                          <SelectItem width="90%" placeholder="Filtrar Proyecto">
                            <Option default value={0}>
                              Niguno
                            </Option>
                            <Option value={1}>Proyectos</Option>
                            <Option value={2}>Unidades de negocio</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const filtrarProyecto =
                              getFieldValue("filtrarProyecto");
                            if (filtrarProyecto === 1) {
                              return (
                                <FormItem required name="proyectos" margin noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Proyectos"
                                    mode="multiple"
                                  >
                                    {this.state.objetoProyectos}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                            if (filtrarProyecto === 2) {
                              return (
                                <FormItem required margin name="unidadDeNegocioId" noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Unidades de Negocio"
                                  >
                                    {this.state.objetoUniadesDeNegocio}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                          }}
                        </FormItem>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabKey="5" key="5" forceRender tab="Detalles">
                    <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                      <Col span={8}>
                        <FormItem
                          label="Desglosar Insumos"
                          name="desglosarInsumos"
                          valuePropName="checked"
                          margin
                        >
                          <Checkbox />
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        {/* <FormItem
                          label="Detalle"
                          name="detalle"
                          valuePropName="checked"
                          margin
                        >
                          <Checkbox />
                        </FormItem> */}
                      </Col>
                    </Row>
                  </TabPane>
                </Tabs>
              </div>
              <TableItem
                onRow={(record, rowIndex) => {
                  return {
                    onDoubleClick: (event) => {
                      this.props.history.push("/panel/verOrdenDeProduccion", {
                        id: record._id,
                      });
                    },
                  };
                }}
                rowKey={(value) => value._id.toString() + Math.random()}
                columns={columns}
                dataSource={this.state.todasProducciones}
                size="small"
                pagination={false}
              />
              {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
            {this.state.pdf && (
              <iframe
                title={"documentos"}
                style={{ width: "100%", height: "100vh" }}
                id="printPdf"
                name="printPdf"
              />
            )}
          </div> */}
            </Spin>
          </Form>
        </>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
    };
  };
  
  export default connect(mapStateToProps)(ReporteCostoProduccion);
  